<template>
  <v-layout fluid>
    <v-layout>
      <div>Name:</div>
      <div style="color: grey; margin-left: 10px;">
        {{ item.first_name + " " + item.last_name }}
      </div>
    </v-layout>
    <v-layout v-if="item.mobile">
      <div>Mobile:</div>
      <div style="color: grey; margin-left: 10px;">{{ item.mobile }}</div>
    </v-layout>
    <v-layout v-if="item.staff_id">
      <div>Staff Key:</div>
      <div style="color: grey; margin-left: 10px;">{{ item.staff_id }}</div>
    </v-layout>
    <v-layout v-if="item.student_id">
      <div>Student ID:</div>
      <div style="color: grey; margin-left: 10px;">
        {{ item.student_id }}
      </div>
    </v-layout>
    <v-layout v-if="item.class && item.class.class_type">
      <div>Class:</div>
      <div style="color: grey; margin-left: 10px;">
        {{ item.class.class_type }}
      </div>
    </v-layout>
    <v-layout v-if="item.active_status">
      <div>Active:</div>
      <div style="color: grey; margin-left: 10px;">
        {{ item.active_status === 1 ? "Active" : "Inactive" }}
      </div>
    </v-layout>
    <v-layout v-if="item.enable_print_label">
      <div>Enable Print Label:</div>
      <div style="color: grey; margin-left: 10px;">
        {{ item.enable_print_label === true ? "Enable" : "Disable" }}
      </div>
    </v-layout>
  </v-layout>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: function() {
        return {};
      }
    }
  }
};
</script>

<style></style>
